globalThis.UserAgent = (function(){
    function UserAgent() { }

    UserAgent.IE10orOlder = function(){
      return window.navigator.userAgent.indexOf('MSIE ') > 0
    }

    UserAgent.IE11 = function(){
      return window.navigator.userAgent.indexOf('Trident/') > 0
    }

    UserAgent.Edge = function(){
      return window.navigator.userAgent.indexOf('Edge/') > 0
    }

    return UserAgent;
})();

